"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const section_icon_1 = __importDefault(require("./section-icon"));
const ProgressContainer = styled_components_1.default.div `
  padding: 8px 0;
`;
const ProgressWrap = styled_components_1.default.div `
  margin: 8px;
  position: relative;
`;
const Progress = styled_components_1.default.progress `
  -webkit-appearance: none;
  appearance: none;
  height: 2px;
  width: 100%;
  &[value] {
    &::-webkit-progress-value {
      background-color: ${(props) => props.$color};
      height: 2px;
    }
    &::-webkit-progress-bar {
      background-color: ${(props) => props.$color}33;
      height: 2px;
    }
  }
`;
const Sections = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
const Icon = styled_components_1.default(section_icon_1.default) `
  color: ${(props) => props.$color};
`;
const Section = styled_components_1.default.div `
  position: absolute;
  color: ${(props) => props.$color};
  left: 0;
  top: -1px;
  transform: translateX(-50%);

  &:first-child {
    transform: translateX(0);
    > svg {
      circle {
        opacity: 1;
      }
    }
  }

  &:last-child {
    left: 100%;
    transform: translateX(-100%);
  }

  ${(props) => !props.complete &&
    `>svg{
      circle{
        opacity:0.2;
        fill:none;
      }
  }`}

  ${(props) => props.inProgress &&
    `>svg{
      circle{
        opacity:1;
        fill:none;
      }
  }`}


  ${(props) => props.complete &&
    `>svg{
      circle{
        fill:currentColor;
      }
  }`}
`;
function ProgressBar({ progress, className, hex }) {
    const [percent, setPercent] = react_1.useState();
    const max = 100;
    react_1.useEffect(() => {
        let newPercent = 0;
        progress.forEach(({ steps, completed }) => {
            // each step takes the same percent of whole, and is then devided into sections.
            const percentPerStep = 100 / progress.length / steps;
            newPercent += completed * percentPerStep;
        });
        setPercent(newPercent);
    }, [progress]);
    const allComplete = progress.every(({ steps, completed }) => steps === completed);
    return (react_1.default.createElement(ProgressContainer, { className: className },
        react_1.default.createElement(ProgressWrap, null,
            react_1.default.createElement(Sections, null, progress.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
                progress.map(({ steps, completed, name }, index) => {
                    return (react_1.default.createElement(Section, { key: name, style: { left: `${(100 / progress.length) * index}%` }, inProgress: completed > 0 && steps !== completed, complete: steps === completed, "$color": hex, "data-name": name, "data-steps": steps, "data-completed": completed },
                        react_1.default.createElement(Icon, { "$color": hex })));
                }),
                react_1.default.createElement(Section, { complete: allComplete },
                    react_1.default.createElement(Icon, { "$color": hex }))))),
            react_1.default.createElement(Progress, { value: percent, max: max, "$color": hex }))));
}
exports.ProgressBar = ProgressBar;
ProgressBar.defaultProps = { progress: [], hex: "#ffffff" };
//# sourceMappingURL=progress-bar.js.map